import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Login from "./Login";
import { login } from "../utils/auth/identity";
const LoginModal = ({ isOpen, onModalClose, onLoginSuccess, onLoginFailure, }) => {
    const handleLogin = (email, password) => {
        login(email, password)
            .then((data) => {
            onLoginSuccess(data);
        })
            .catch((error) => {
            onLoginFailure(error.errorMessage);
            return;
        });
    };
    return (React.createElement(Dialog, { open: isOpen, onClose: onModalClose, maxWidth: "sm", fullWidth: true },
        React.createElement(DialogTitle, { sx: { fontSize: "1.2em" } }, "Login"),
        React.createElement(DialogContent, null,
            React.createElement(Login, { onLogIn: handleLogin })),
        React.createElement(DialogActions, { sx: {
                position: "absolute",
                top: 0,
                right: 0,
                padding: 0, // Remove default padding
            } },
            React.createElement(Button, { onClick: onModalClose, sx: {
                    color: "#000000",
                    minWidth: "auto", // Ensure the button doesn't have a minimum width
                    padding: "8px", // Adjust padding as needed
                } },
                React.createElement(CloseIcon, null)))));
};
export default LoginModal;
